import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const HOLA_DARK = "#005760";

const tabClass = ({ isActive }) =>
  [
    "px-3 py-2.5 text-sm font-semibold rounded-t-lg border-b-2 -mb-px transition-colors",
    isActive
      ? "border-teal-700 text-teal-900 bg-teal-50/80"
      : "border-transparent text-slate-600 hover:text-teal-800 hover:bg-teal-50/40",
  ].join(" ");

const HolaAdminLayout = () => (
  <div className="w-full max-w-7xl mx-auto h-full min-h-0 flex flex-col">
    <nav
      className="flex-shrink-0 flex flex-wrap gap-1 border-b border-slate-200 mb-1"
      aria-label="Hola admin sections"
    >
      <NavLink to="/hola-admin/overview" className={tabClass}>
        Overview
      </NavLink>
      <NavLink to="/hola-admin/reports" className={tabClass}>
        Reports
      </NavLink>
    </nav>
    <div className="flex-1 min-h-0 min-w-0 flex flex-col">
      <Outlet />
    </div>
  </div>
);

export default HolaAdminLayout;
